module.exports = __webpack_public_path__ + "media/images/d_screen_universes-67fc6676ed90d49f044b51f87176c127.svg";